import type { Endpoint, Request, RequestArgs, Route } from '../types.no-deps'
import type { UUID } from '../../../shared/lib/typeHelpers.no-deps'

export const route: Route = { method: 'POST', pattern: '/api/notifications/markAsRead' }

type Params = never

type Body = {
    postEvents?: UUID[]
    postComments?: UUID[]
    scheduledInstances?: UUID[]
    notificationIds?: UUID[]
    // Old clients may send these, we ignore them but don't reject the request
    scheduleReminders?: UUID[]
}

type Query = never

type Output = never

export type MarkNotificationsAsReadEndpoint = Endpoint<Params, Body, Query, Output>

export const markNotificationsAsReadRequest = (request: Request, args: RequestArgs<MarkNotificationsAsReadEndpoint>) =>
    request<MarkNotificationsAsReadEndpoint>(route, args)
